/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Update_SuccessInputs */

const en_admin_payments_update_success = /** @type {(inputs: Admin_Payments_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order updated`)
};

/**
* | output |
* | --- |
* | "Order updated" |
*
* @param {Admin_Payments_Update_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_update_success = /** @type {((inputs?: Admin_Payments_Update_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Update_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_update_success(inputs)
});
export { admin_payments_update_success as "admin.payments.update_success" }